import d3 from '@/utils/d3importer'
export default function() {
  
  let x, y;
  let brush = d3.brush().extent([[0,0],[100,100]])
  let w,h;
  let drawOverlay = function () {
    let sel = d3.event.selection
    let ol = d3.select(this)
      .selectAll(".hole-overlay").data([null])
    ol = ol.merge(ol.enter().append('path').attr('class','hole-overlay'))
    // d3.select(this).select('.overlay').style('pointer-events','none')
    // console.log("drawn with sel: ",sel)   
    ol.attr("d", function(d) {
      if(!sel) return ''
      let rect = `M ${sel[0][0]} ${sel[0][1]} L ${sel[0][0]} ${sel[1][1]} L ${sel[1][0]} ${sel[1][1]} L ${sel[1][0]} ${sel[0][1]} L ${sel[0][0]} ${sel[0][1]}`
      return `M 0 0 h ${w} v ${h} h -${w} v -${h}` + rect + "Z" ;
    });
    return true
  }
  brush.on('start.internal brush.internal end.internal',drawOverlay)
  brush.isWithinExtent = function(x, y) {
    let ext = d3.event.selection
    if(!ext) return false
    return ext[0][0]<=x && ext[0][1]<=y && x<=ext[1][0] && y<=ext[1][1]
  }
  brush.x = function(z) {
    if (!arguments.length) {
        return x;
    }
    x = z;
    w = x.range()[1]-x.range()[0]
    let ext = brush.extent()()
    let rng = z.range()
    brush.extent([[rng[0],ext[0][1]],[rng[1],ext[1][1]]])
    return brush;
  };
  brush.y = function(z) {
      if (!arguments.length) {
          return y;
      }
      y = z;
      h = y.range()[0]-y.range()[1]
      let ext = brush.extent()()
      let rng = z.range()
      brush.extent([[ext[0][0],rng[1]],[ext[1][0],rng[0]]])
      return brush;
  };
  return brush
}